/* Metacards — "How you pay" 3D scene. Android POS (Indian handheld style) + ATM.
   three.js r128 loads only when the block scrolls near. Renders only while visible. */
(function () {
  'use strict';
  var stage = document.querySelector('[data-mp-pay]');
  if (!stage) return;
  var wrap = stage.closest('.mp__pay') || document;
  var canvas = stage.querySelector('canvas'), cap = stage.querySelector('[data-pay-cap]');
  var tabs = wrap.querySelectorAll('[data-pay-mode]');
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var api = { finish: stage.getAttribute('data-fin') || 'black-gold', name: stage.getAttribute('data-name') || 'AARAV MEHTA' };
  window.mcPay = { setFinish: function (f) { api.finish = f; if (api.apply) api.apply(); }, setName: function (n) { api.name = n || stage.getAttribute('data-name') || ''; if (api.apply) api.apply(); } };

  var loaded = false;
  function load() {
    if (loaded) return; loaded = true;
    if (window.THREE) return boot();
    var s = document.createElement('script'); s.src = THREE_URL; s.async = true; s.onload = boot;
    s.onerror = function () { stage.classList.add('is-fallback'); };
    document.head.appendChild(s);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { load(); o.disconnect(); } }, { rootMargin: '300px' }).observe(stage);
  } else load();

  /* ---------- small math ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function seg(t, a, b) { return ease(clamp((t - a) / (b - a), 0, 1)); }
  function mix(a, b, k) { return a + (b - a) * k; }
  function mixA(a, b, k) { return a.map(function (v, i) { return mix(v, b[i], k); }); }

  function boot() {
    var T = window.THREE;
    var R = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    R.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    R.outputEncoding = T.sRGBEncoding;
    R.toneMapping = T.ACESFilmicToneMapping;
    R.toneMappingExposure = 1.05;
    var S = new T.Scene();

    /* studio reflections: a soft-box room baked into an environment map */
    (function () {
      var pm = new T.PMREMGenerator(R), es = new T.Scene();
      es.add(new T.Mesh(new T.BoxGeometry(40, 40, 40), new T.MeshBasicMaterial({ color: 0x3c3c44, side: T.BackSide })));
      function box(w, h, x, y, z, rx, ry, k) {
        var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(k, k, k), side: T.DoubleSide }));
        m.position.set(x, y, z); m.rotation.set(rx, ry, 0); es.add(m);
      }
      box(16, 6, 0, 16, 2, Math.PI / 2, 0, 5);
      box(7, 14, -18, 3, 4, 0, Math.PI / 2, 2.6);
      box(7, 14, 18, 1, -3, 0, -Math.PI / 2, 1.6);
      box(24, 5, 0, 0, -19, 0, 0, 1.1);
      box(10, 3, 0, -12, 14, -Math.PI / 3, 0, 0.9);
      S.environment = pm.fromScene(es, 0.035).texture;
    })();
    S.add(new T.HemisphereLight(0xffffff, 0x8e8e96, 0.5));
    var key = new T.DirectionalLight(0xffffff, 1.0); key.position.set(-8, 12, 14); S.add(key);
    var rim = new T.DirectionalLight(0xffffff, 0.45); rim.position.set(10, 5, -10); S.add(rim);

    var cam = new T.PerspectiveCamera(26, 1, 0.1, 400);

    /* ---------- builders ---------- */
    function rr(w, h, r) {
      var s = new T.Shape(), x = -w / 2, y = -h / 2;
      s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
      s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
      s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y); return s;
    }
    function rbox(w, h, d, r, mat, b) {
      b = b == null ? Math.min(r * .5, d * .3) : b;
      var g = new T.ExtrudeGeometry(rr(w - 2 * b, h - 2 * b, Math.max(r - b, .02)), { depth: Math.max(d - 2 * b, .001), bevelEnabled: true, bevelThickness: b, bevelSize: b, bevelSegments: 4, curveSegments: 12 });
      g.translate(0, 0, -(d - 2 * b) / 2);
      return new T.Mesh(g, mat);
    }
    function std(c, r, m, o) { var p = { color: c, roughness: r, metalness: m }; if (o) for (var k in o) p[k] = o[k]; return new T.MeshStandardMaterial(p); }
    function cnv(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
    function tex(c) { var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.anisotropy = R.capabilities.getMaxAnisotropy ? Math.min(8, R.capabilities.getMaxAnisotropy()) : 4; return t; }
    function screen(w, h, px) {
      var c = cnv(px, Math.round(px * h / w)), t = tex(c);
      var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ map: t, toneMapped: false }));
      return { mesh: m, c: c, x: c.getContext('2d'), t: t, key: '' };
    }
    function shadow(w, h) {
      var c = cnv(128, 128), x = c.getContext('2d'), g = x.createRadialGradient(64, 64, 0, 64, 64, 64);
      g.addColorStop(0, 'rgba(0,0,0,.34)'); g.addColorStop(.55, 'rgba(0,0,0,.12)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = g; x.fillRect(0, 0, 128, 128);
      var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ map: new T.CanvasTexture(c), transparent: true, depthWrite: false }));
      m.rotation.x = -Math.PI / 2; return m;
    }
    var FONT = '-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif';
    function txt(x, s, size, weight, color, px, py, align) { x.font = weight + ' ' + size + 'px ' + FONT; x.fillStyle = color; x.textAlign = align || 'center'; x.textBaseline = 'middle'; x.fillText(s, px, py); }
    function rrect(x, px, py, w, h, r) { x.beginPath(); x.moveTo(px + r, py); x.arcTo(px + w, py, px + w, py + h, r); x.arcTo(px + w, py + h, px, py + h, r); x.arcTo(px, py + h, px, py, r); x.arcTo(px, py, px + w, py, r); x.closePath(); }
    function check(x, cx, cy, r, color) { x.fillStyle = color; x.beginPath(); x.arc(cx, cy, r, 0, 7); x.fill(); x.strokeStyle = '#fff'; x.lineWidth = r * .16; x.lineCap = 'round'; x.lineJoin = 'round'; x.beginPath(); x.moveTo(cx - r * .42, cy + r * .02); x.lineTo(cx - r * .1, cy + r * .34); x.lineTo(cx + r * .45, cy - r * .3); x.stroke(); }
    function spinner(x, cx, cy, r, time, color) { x.strokeStyle = color; x.lineWidth = r * .18; x.lineCap = 'round'; x.beginPath(); var a = time * 5; x.arc(cx, cy, r, a, a + 4.2); x.stroke(); }

    /* ---------- the metal card (real ISO size, cm) ---------- */
    /* finishes painted procedurally, so no image downloads are needed */
    var FIN = {
      'black-gold': { a: '#18181A', b: '#303034', e: '#C9A55A', edge: '#2A2A2D', gl: .18 },
      'black-silver': { a: '#18181A', b: '#303034', e: '#C9CDD2', edge: '#2A2A2D', gl: .18 },
      'glossy-black': { a: '#050506', b: '#26262A', e: '#DADDE1', edge: '#161618', gl: .45 },
      'matte-gold': { a: '#A68850', b: '#D0B57E', e: 'rgba(255,255,255,.85)', edge: '#B99557', gl: .12 },
      'gold': { a: '#C39A48', b: '#F1D896', e: 'rgba(255,255,255,.9)', edge: '#D2AE5E', gl: .45 },
      'brushed': { a: '#A5A9AE', b: '#D6D9DD', e: 'rgba(30,30,35,.6)', edge: '#BFC3C8', gl: .15, brush: 1 },
      'silver': { a: '#B9BDC2', b: '#F3F4F5', e: 'rgba(30,30,35,.55)', edge: '#D5D8DC', gl: .45 },
      'rose': { a: '#CB9889', b: '#F0CFC4', e: 'rgba(255,255,255,.9)', edge: '#D7A99C', gl: .4 },
      'white': { a: '#E6E6EA', b: '#FFFFFF', e: '#B8964E', edge: '#E0E0E4', gl: .2 }
    };
    function metal(x, f, W, H) {
      var g = x.createLinearGradient(0, 0, W, H); g.addColorStop(0, f.a); g.addColorStop(.55, f.b); g.addColorStop(1, f.a);
      x.fillStyle = g; x.fillRect(0, 0, W, H);
      if (f.brush) { x.globalAlpha = .08; for (var i = 0; i < H; i += 2) { x.fillStyle = i % 4 ? '#fff' : '#000'; x.fillRect(0, i, W, 1); } x.globalAlpha = 1; }
      var s = x.createLinearGradient(0, 0, W, H * .6); s.addColorStop(.35, 'rgba(255,255,255,0)'); s.addColorStop(.5, 'rgba(255,255,255,' + f.gl + ')'); s.addColorStop(.65, 'rgba(255,255,255,0)');
      x.fillStyle = s; x.fillRect(0, 0, W, H);
    }
    function chip(x, px, py) {
      var w = 130, h = 100, g = x.createLinearGradient(px, py, px + w, py + h); g.addColorStop(0, '#E9D9A6'); g.addColorStop(.5, '#C7A968'); g.addColorStop(1, '#E3CF96');
      x.fillStyle = g; rrect(x, px, py, w, h, 16); x.fill();
      x.strokeStyle = 'rgba(90,70,30,.55)'; x.lineWidth = 3;
      x.beginPath(); x.moveTo(px, py + h / 2); x.lineTo(px + w * .36, py + h / 2); x.moveTo(px + w * .64, py + h / 2); x.lineTo(px + w, py + h / 2);
      x.moveTo(px + w * .36, py); x.lineTo(px + w * .36, py + h); x.moveTo(px + w * .64, py); x.lineTo(px + w * .64, py + h);
      x.moveTo(px, py + h * .25); x.lineTo(px + w * .36, py + h * .25); x.moveTo(px, py + h * .75); x.lineTo(px + w * .36, py + h * .75);
      x.moveTo(px + w * .64, py + h * .25); x.lineTo(px + w, py + h * .25); x.moveTo(px + w * .64, py + h * .75); x.lineTo(px + w, py + h * .75); x.stroke();
    }
    function makeCard() {
      var W = 8.56, H = 5.398, D = .08, r = .32;
      var fc = cnv(1024, 646), bc = cnv(1024, 646), ft = tex(fc), bt = tex(bc);
      function capGeo(g) { var p = g.attributes.position, uv = g.attributes.uv; for (var i = 0; i < p.count; i++) uv.setXY(i, (p.getX(i) + W / 2) / W, (p.getY(i) + H / 2) / H); return g; }
      var geo = capGeo(new T.ExtrudeGeometry(rr(W, H, r), { depth: D, bevelEnabled: false, curveSegments: 12 })); geo.translate(0, 0, -D / 2);
      var edge = std(0xcaa45a, .3, .9);
      var front = new T.MeshPhysicalMaterial({ map: ft, roughness: .34, metalness: .3, clearcoat: .9, clearcoatRoughness: .1 });
      var back = new T.MeshPhysicalMaterial({ map: bt, roughness: .38, metalness: .3, clearcoat: .8, clearcoatRoughness: .14 });
      var m = new T.Mesh(geo, [front, edge]);
      var bm = new T.Mesh(capGeo(new T.ShapeGeometry(rr(W, H, r), 12)), back); bm.rotation.y = Math.PI; bm.position.z = -D / 2 - .003;
      var g = new T.Group(); g.add(m, bm);
      return { g: g, draw: function (key, name) {
        var f = FIN[key] || FIN['black-gold'];
        var x = fc.getContext('2d'); metal(x, f, 1024, 646); chip(x, 110, 250);
        x.fillStyle = f.e; x.textAlign = 'right'; x.textBaseline = 'alphabetic'; x.font = '600 30px ' + FONT; x.fillText('M E T A C A R D S', 950, 590);
        var y = bc.getContext('2d'); metal(y, f, 1024, 646);
        var MONO = '"SF Mono",Menlo,"Courier New",monospace';
        y.fillStyle = '#050506'; y.fillRect(0, 52, 1024, 90);
        y.fillStyle = '#F4F4F2'; y.fillRect(61, 207, 584, 90);
        y.fillStyle = f.e; y.textBaseline = 'alphabetic'; y.textAlign = 'left';
        y.font = '400 22px ' + MONO; y.fillText('SIGN', 61, 196);
        y.font = '400 46px ' + MONO; y.fillText('123', 686, 268);
        y.font = '400 72px ' + MONO; y.fillText('5241 2345 6789 8830', 61, 408);
        y.font = '400 44px ' + MONO; y.fillText(name, 61, 478);
        y.font = '400 22px ' + MONO; y.fillText('Valid Thru', 61, 520);
        y.font = '400 46px ' + MONO; y.fillText('08/31', 61, 568);
        y.font = '400 24px ' + MONO; y.fillText('Services: 0000-000-0000', 61, 618);
        ft.needsUpdate = bt.needsUpdate = true; edge.color.set(f.edge); if (api.kick) api.kick();
      } };
    }

    /* =========================================================
       ANDROID POS — tall handheld: printer hump on top, big
       touchscreen, chip slot on the bottom edge (card goes in
       face-up, chip first, parallel to the screen).
       ========================================================= */
    var pos = new T.Group(), posRig = new T.Group(); pos.add(posRig);
    var charcoal = std(0x131417, .48, .25), graphite = std(0x1c1d21, .42, .3), black = std(0x050506, .9, 0);
    var glass = new T.MeshPhysicalMaterial({ color: 0x030304, roughness: .06, metalness: 0, clearcoat: 1, clearcoatRoughness: .04 });
    posRig.add(rbox(7.8, 17.4, 1.7, .95, charcoal));
    var hump = rbox(7.8, 6.2, 1.6, .95, graphite); hump.position.set(0, 5.6, -1.2); posRig.add(hump);
    var seam = new T.Mesh(new T.BoxGeometry(7.2, .04, .05), black); seam.position.set(0, 7.1, -.38); posRig.add(seam);
    var paperSlot = new T.Mesh(new T.BoxGeometry(6.0, .08, .32), black); paperSlot.position.set(0, 8.69, -1.25); posRig.add(paperSlot);
    var g1 = rbox(7.0, 12.4, .06, .55, glass); g1.position.set(0, 1.25, .86); posRig.add(g1);
    var ps = screen(6.3, 11.0, 360); ps.mesh.position.set(0, 1.35, .9); posRig.add(ps.mesh);
    var chipSlot = new T.Mesh(new T.BoxGeometry(6.1, .14, .36), black); chipSlot.position.set(0, -8.68, .1); posRig.add(chipSlot);
    var pwr = rbox(.14, 1.3, .36, .06, graphite); pwr.position.set(3.93, 3.4, 0); posRig.add(pwr);
    var vol = rbox(.14, 2.0, .36, .06, graphite); vol.position.set(-3.93, 3.0, 0); posRig.add(vol);
    // printed "insert here" mark above the chip slot
    (function () {
      var c = cnv(256, 64), x = c.getContext('2d'); x.strokeStyle = '#8a8a92'; x.lineWidth = 4; x.lineJoin = 'round';
      rrect(x, 96, 10, 64, 40, 6); x.stroke(); x.fillStyle = '#8a8a92'; x.fillRect(106, 20, 14, 11);
      x.beginPath(); x.moveTo(128, 56); x.lineTo(118, 46); x.moveTo(128, 56); x.lineTo(138, 46); x.stroke();
      var m = new T.Mesh(new T.PlaneGeometry(2.2, .55), new T.MeshBasicMaterial({ map: tex(c), transparent: true }));
      m.position.set(0, -7.75, .861); posRig.add(m);
    })();
    // receipt paper coming out of the printer
    var rc = cnv(300, 720), rx = rc.getContext('2d');
    rx.fillStyle = '#FBFBF8'; rx.fillRect(0, 0, 300, 720);
    for (var i = 0; i < 300; i += 12) { rx.fillStyle = '#FBFBF8'; rx.beginPath(); rx.moveTo(i, 0); rx.lineTo(i + 6, 8); rx.lineTo(i + 12, 0); rx.fill(); }
    txt(rx, 'SALE', 30, '700', '#222', 150, 60); txt(rx, 'CHIP · PIN VERIFIED', 16, '500', '#555', 150, 100);
    rx.fillStyle = '#ccc'; for (i = 20; i < 280; i += 10) rx.fillRect(i, 128, 5, 2);
    txt(rx, 'CARD', 18, '500', '#444', 30, 170, 'left'); txt(rx, '**** 8830', 18, '600', '#222', 270, 170, 'right');
    txt(rx, 'AMOUNT', 18, '500', '#444', 30, 210, 'left'); txt(rx, '₹2,450.00', 22, '700', '#111', 270, 210, 'right');
    txt(rx, 'APPROVED', 26, '700', '#111', 150, 280);
    rx.fillStyle = '#ccc'; for (i = 20; i < 280; i += 10) rx.fillRect(i, 320, 5, 2);
    txt(rx, 'Thank you', 18, '500', '#555', 150, 360);
    var receiptMat = std(0xffffff, .9, 0, { map: tex(rc), transparent: true, side: T.DoubleSide });
    var receiptPivot = new T.Group(); receiptPivot.position.set(0, 8.69, -1.25); posRig.add(receiptPivot);
    var receipt = new T.Mesh(new T.PlaneGeometry(5.6, 6.0), receiptMat); receiptPivot.add(receipt);
    var posShadow = shadow(16, 7); posShadow.position.y = -14.6; pos.add(posShadow);
    var posCard = makeCard(), posCardHold = new T.Group(); posCard.g.rotation.z = -Math.PI / 2; posCardHold.add(posCard.g); posRig.add(posCardHold);

    function posUI(st, n, hl, time) {
      var x = ps.x, W = ps.c.width, H = ps.c.height;
      x.fillStyle = '#F2F3F5'; x.fillRect(0, 0, W, H);
      x.fillStyle = '#101114'; x.fillRect(0, 0, W, 30); txt(x, '12:30', 15, '600', '#fff', 18, 15, 'left'); txt(x, '4G ▮▮▮', 13, '600', '#fff', W - 16, 15, 'right');
      txt(x, 'Sale', 17, '600', '#6b6b72', W / 2, 62);
      if (st === 'insert' || st === 'remove') {
        txt(x, 'Amount', 16, '500', '#8a8a92', W / 2, 118); txt(x, '₹2,450.00', 46, '700', '#111', W / 2, 166);
        var bob = st === 'insert' ? Math.sin(time * 5) * 7 : -Math.sin(time * 5) * 7;
        x.strokeStyle = '#111'; x.lineWidth = 5; rrect(x, W / 2 - 58, 270, 116, 150, 12); x.stroke();
        x.fillStyle = '#C9A55A'; rrect(x, W / 2 - 38, 300, 34, 26, 5); x.fill();
        x.strokeStyle = '#1E6FD9'; x.lineWidth = 7; x.lineCap = 'round'; x.beginPath();
        var ay = 470 + bob; x.moveTo(W / 2, ay - 26); x.lineTo(W / 2, ay + 16); x.moveTo(W / 2 - 16, ay); x.lineTo(W / 2, ay + 16); x.lineTo(W / 2 + 16, ay); x.stroke();
        txt(x, st === 'insert' ? 'Insert card' : 'Remove card', 30, '700', '#111', W / 2, 548);
        txt(x, st === 'insert' ? 'Chip slot at the bottom' : 'Payment complete', 17, '500', '#6b6b72', W / 2, 584);
      } else if (st === 'pin') {
        txt(x, 'Enter PIN', 30, '700', '#111', W / 2, 110); txt(x, '₹2,450.00', 18, '500', '#6b6b72', W / 2, 146);
        for (var d = 0; d < 4; d++) { x.beginPath(); x.arc(W / 2 - 60 + d * 40, 196, 10, 0, 7); if (d < n) { x.fillStyle = '#111'; x.fill(); } else { x.strokeStyle = '#9a9aa2'; x.lineWidth = 2.5; x.stroke(); } }
        var labels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '✕', '0', '✓'];
        for (var k = 0; k < 12; k++) {
          var cx = 22 + (k % 3) * 108, cy = 238 + Math.floor(k / 3) * 94;
          x.fillStyle = k === hl ? '#1E6FD9' : (k === 9 ? '#FBE3E3' : k === 11 ? '#DDF3E6' : '#FFFFFF');
          rrect(x, cx, cy, 100, 84, 14); x.fill();
          txt(x, labels[k], 32, '600', k === hl ? '#fff' : '#111', cx + 50, cy + 43);
        }
      } else if (st === 'proc') {
        txt(x, '₹2,450.00', 34, '700', '#111', W / 2, 150); spinner(x, W / 2, 330, 46, time, '#1E6FD9'); txt(x, 'Processing', 26, '600', '#111', W / 2, 440);
        txt(x, 'Do not remove card', 17, '500', '#6b6b72', W / 2, 476);
      } else if (st === 'ok') {
        check(x, W / 2, 250, 72, '#1E9E57'); txt(x, 'Approved', 36, '700', '#111', W / 2, 380); txt(x, '₹2,450.00', 24, '600', '#111', W / 2, 424);
        txt(x, 'Printing receipt', 17, '500', '#6b6b72', W / 2, 470);
      }
      ps.t.needsUpdate = true;
    }

    /* =========================================================
       ATM — fascia with screen, card reader (lit bezel) on the
       right, keypad shelf, cash slot. Card goes in flat, chip first.
       ========================================================= */
    var atm = new T.Group(), atmRig = new T.Group(); atm.add(atmRig); atm.scale.setScalar(.62);
    var steel = std(0xc3c6cb, .36, .75), dark = std(0x1b1c20, .5, .25);
    atmRig.add(rbox(22, 34, 7, 1.2, steel));
    var head = rbox(22.2, 5.2, 7.3, 1.2, dark); head.position.y = 14.5; atmRig.add(head);
    (function () {
      var c = cnv(256, 64), x = c.getContext('2d'); txt(x, 'ATM', 40, '800', '#EDEDF0', 128, 34);
      var m = new T.Mesh(new T.PlaneGeometry(4.2, 1.05), new T.MeshBasicMaterial({ map: tex(c), transparent: true, toneMapped: false })); m.position.set(0, 14.5, 3.67); atmRig.add(m);
    })();
    var surround = rbox(17.6, 12.4, .7, .7, dark); surround.position.set(0, 5.6, 3.55); atmRig.add(surround);
    var as = screen(15.2, 10.2, 640); as.mesh.position.set(0, 5.6, 3.92); atmRig.add(as.mesh);
    var ag = rbox(15.6, 10.6, .04, .3, glass); ag.position.set(0, 5.6, 3.95); ag.material = new T.MeshPhysicalMaterial({ color: 0xffffff, transparent: true, opacity: .08, roughness: .05, clearcoat: 1 }); atmRig.add(ag);
    // card reader
    var reader = rbox(7.4, 2.8, 1.8, .6, dark); reader.position.set(5.9, -2.4, 4.2); atmRig.add(reader);
    var ledMat = std(0x0c7a3a, .4, 0, { emissive: 0x19d46a, emissiveIntensity: .6 });
    var led = rbox(6.8, 1.3, .24, .4, ledMat); led.position.set(5.9, -2.4, 5.08); atmRig.add(led);
    var slit = new T.Mesh(new T.BoxGeometry(6.2, .2, .3), black); slit.position.set(5.9, -2.4, 5.12); atmRig.add(slit);
    // keypad shelf
    var shelf = new T.Group(); shelf.position.set(-4.2, -4.6, 4.3); shelf.rotation.x = -.55; atmRig.add(shelf);
    shelf.add(rbox(10.6, 7.6, 1.0, .5, dark));
    var keyMat = std(0xd9dbde, .3, .8), keys = [];
    var fn = [std(0xc8352e, .4, .2), std(0xe0b21c, .4, .2), std(0x2a9d55, .4, .2), std(0xd9dbde, .3, .8)];
    for (var r = 0; r < 4; r++) for (var c = 0; c < 4; c++) {
      var k = rbox(c === 3 ? 2.2 : 1.9, 1.3, .45, .25, c === 3 ? fn[r] : keyMat); k.position.set(-3.7 + c * 2.35 + (c === 3 ? .2 : 0), 2.4 - r * 1.6, .62); shelf.add(k); keys.push(k);
    }
    // cash slot + notes
    var cashBezel = rbox(17, 2.4, 1.4, .6, dark); cashBezel.position.set(0, -11.2, 4.0); atmRig.add(cashBezel);
    var cashSlit = new T.Mesh(new T.BoxGeometry(15.8, .34, .3), black); cashSlit.position.set(0, -11.2, 4.62); atmRig.add(cashSlit);
    var nc = cnv(600, 264), nx = nc.getContext('2d');
    nx.fillStyle = '#C8CAB6'; nx.fillRect(0, 0, 600, 264); nx.strokeStyle = '#9C9E88'; nx.lineWidth = 6; nx.strokeRect(14, 14, 572, 236);
    nx.fillStyle = 'rgba(120,124,100,.25)'; nx.beginPath(); nx.arc(170, 132, 70, 0, 7); nx.fill();
    txt(nx, '500', 70, '800', '#5E604E', 470, 150); txt(nx, '₹', 44, '700', '#5E604E', 60, 70);
    var noteMat = std(0xffffff, .85, 0, { map: tex(nc), side: T.DoubleSide, transparent: true });
    var notes = new T.Group(); notes.position.set(0, -11.2, 0); atmRig.add(notes);
    for (i = 0; i < 4; i++) { var nm = new T.Mesh(new T.PlaneGeometry(15, 6.6), noteMat); nm.rotation.x = -Math.PI / 2 + .12; nm.position.y = -.12 + i * .06; notes.add(nm); }
    var atmShadow = shadow(34, 12); atmShadow.position.y = -17.3; atm.add(atmShadow);
    var atmCard = makeCard(), atmCardHold = new T.Group(), atmCardFlat = new T.Group();
    atmCard.g.rotation.z = -Math.PI / 2; atmCardFlat.rotation.x = -Math.PI / 2; atmCardFlat.add(atmCard.g); atmCardHold.add(atmCardFlat); atmRig.add(atmCardHold);

    function atmUI(st, n, time) {
      var x = as.x, W = as.c.width, H = as.c.height;
      var g = x.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#12467A'); g.addColorStop(1, '#0A2748'); x.fillStyle = g; x.fillRect(0, 0, W, H);
      x.fillStyle = 'rgba(255,255,255,.08)'; x.fillRect(0, 0, W, 44); txt(x, 'Welcome', 20, '600', '#DDE8F5', 22, 22, 'left'); txt(x, 'English · हिन्दी', 18, '500', '#A9C1DB', W - 22, 22, 'right');
      if (st === 'welcome') {
        txt(x, 'Please insert your card', 36, '700', '#fff', W / 2, 150);
        var bob = Math.sin(time * 5) * 8;
        x.strokeStyle = '#fff'; x.lineWidth = 5; rrect(x, W / 2 - 150 + bob, 230, 150, 96, 12); x.stroke(); x.fillStyle = '#E8C66A'; rrect(x, W / 2 - 132 + bob, 256, 32, 24, 5); x.fill();
        x.strokeStyle = '#7CE0A6'; x.lineWidth = 7; x.lineCap = 'round'; x.beginPath(); x.moveTo(W / 2 + 40, 278); x.lineTo(W / 2 + 130, 278); x.moveTo(W / 2 + 110, 258); x.lineTo(W / 2 + 130, 278); x.lineTo(W / 2 + 110, 298); x.stroke();
        txt(x, 'Chip first, face up', 20, '500', '#A9C1DB', W / 2, 370);
      } else if (st === 'pin') {
        txt(x, 'Enter your PIN', 36, '700', '#fff', W / 2, 140);
        for (var d = 0; d < 4; d++) { x.strokeStyle = '#fff'; x.lineWidth = 3; rrect(x, W / 2 - 150 + d * 78, 200, 66, 76, 10); x.stroke(); if (d < n) { x.fillStyle = '#fff'; x.beginPath(); x.arc(W / 2 - 117 + d * 78, 238, 10, 0, 7); x.fill(); } }
        txt(x, 'Cover the keypad while typing', 20, '500', '#A9C1DB', W / 2, 340);
      } else if (st === 'amount') {
        txt(x, 'Enter amount', 36, '700', '#fff', W / 2, 140);
        x.fillStyle = 'rgba(255,255,255,.12)'; rrect(x, W / 2 - 170, 196, 340, 90, 12); x.fill();
        txt(x, '₹ ' + (['', '2', '20', '200', '2,000'][n] || '') + (Math.floor(time * 2) % 2 ? '|' : ' '), 44, '700', '#fff', W / 2, 243);
      } else if (st === 'proc') {
        spinner(x, W / 2, 190, 44, time, '#7CE0A6'); txt(x, 'Please wait', 32, '700', '#fff', W / 2, 290);
      } else if (st === 'card') {
        txt(x, 'Please take your card', 36, '700', '#fff', W / 2, 170); txt(x, 'Your cash is on its way', 20, '500', '#A9C1DB', W / 2, 230);
      } else if (st === 'cash') {
        check(x, W / 2, 170, 52, '#1E9E57'); txt(x, 'Please collect your cash', 34, '700', '#fff', W / 2, 280); txt(x, '₹2,000', 24, '600', '#DDE8F5', W / 2, 326);
      } else {
        txt(x, 'Thank you', 40, '700', '#fff', W / 2, 190);
      }
      as.t.needsUpdate = true;
    }

    S.add(pos, atm);

    /* ---------- finish + name ---------- */
    api.apply = function () { posCard.draw(api.finish, api.name); atmCard.draw(api.finish, api.name); };
    api.apply();

    /* ---------- timelines ---------- */
    var mode = 'pos', t0 = performance.now(), caption = '';
    var MODES = {
      pos: { dur: 10.4, rest: 6.6, target: [0, -1.2, 0], dist: 60, yaw: -.42, pitch: .16 },
      atm: { dur: 12.6, rest: 10.2, target: [0, -.6, 0], dist: 66, yaw: -.55, pitch: .12 }
    };
    function say(s) { if (s !== caption) { caption = s; if (cap) cap.textContent = s; } }

    var P_A = [5.5, -16, 6], P_Ar = [.55, -.7, .35], P_B = [0, -14.3, .1], P_C = [0, -7.7, .1];
    function runPos(t, time) {
      var p = P_B, rot = [0, 0, 0];
      var a = seg(t, .2, 1.6), b = seg(t, 1.9, 2.7), c = seg(t, 7.9, 8.6), d = seg(t, 8.8, 9.9);
      if (t < 1.9) { p = mixA(P_A, P_B, a); rot = mixA(P_Ar, [0, 0, 0], a); }
      else if (t < 7.9) p = mixA(P_B, P_C, b);
      else if (t < 8.8) p = mixA(P_C, P_B, c);
      else { p = mixA(P_B, P_A, d); rot = mixA([0, 0, 0], P_Ar, d); }
      posCardHold.position.set(p[0], p[1], p[2]); posCardHold.rotation.set(rot[0], rot[1], rot[2]);
      var st, n = 0, hl = -1, seq = [4, 1, 8, 10];
      if (t < 2.7) st = 'insert';
      else if (t < 4.8) { st = 'pin'; [3.1, 3.5, 3.9, 4.3].forEach(function (s, i) { if (t > s) n = i + 1; if (t > s && t < s + .22) hl = seq[i]; }); }
      else if (t < 5.6) st = 'proc';
      else if (t < 7.8) st = 'ok';
      else if (t < 8.9) st = 'remove';
      else st = 'insert';
      var anim = st === 'insert' || st === 'remove' || st === 'proc';
      var keyStr = st + n + hl;
      if (anim || keyStr !== ps.key) { ps.key = keyStr; posUI(st, n, hl, time); }
      var e = seg(t, 5.9, 7.6) * 5.2;
      receipt.visible = t > 5.85;
      receipt.position.y = -3 + e; receiptPivot.rotation.x = -.22 * seg(t, 6.6, 7.8);
      receiptMat.opacity = 1 - seg(t, 9.6, 10.3);
      say(st === 'insert' ? (t < 2 ? 'Insert the card, chip first' : 'Card goes in the slot at the bottom') : st === 'pin' ? 'Enter your PIN on the machine' : st === 'proc' ? 'Processing' : st === 'ok' ? 'Approved. The receipt prints' : 'Take your card back');
    }
    var A_A = [13, 4, 16], A_Ar = [.7, .9, -.3], A_B = [5.9, -2.4, 10.4], A_C = [5.9, -2.4, 3.0], A_D = [5.9, -2.4, 7.2];
    function runAtm(t, time) {
      var p = A_B, rot = [0, 0, 0];
      if (t < 1.9) { var a = seg(t, .2, 1.6); p = mixA(A_A, A_B, a); rot = mixA(A_Ar, [0, 0, 0], a); }
      else if (t < 7.3) p = mixA(A_B, A_C, seg(t, 1.9, 2.8));
      else if (t < 8.5) p = mixA(A_C, A_D, seg(t, 7.3, 7.9));
      else { var d = seg(t, 8.5, 9.5); p = mixA(A_D, A_A, d); rot = mixA([0, 0, 0], A_Ar, d); }
      atmCardHold.position.set(p[0], p[1], p[2]); atmCardHold.rotation.set(rot[0], rot[1], rot[2]);
      var st, n = 0, press = -1;
      var pinT = [3.3, 3.7, 4.1, 4.5], pinK = [5, 0, 9, 13], amtT = [5.4, 5.7, 6.0, 6.3];
      if (t < 2.9) st = 'welcome';
      else if (t < 5.0) { st = 'pin'; pinT.forEach(function (s, i) { if (t > s) n = i + 1; if (t > s && t < s + .18) press = pinK[i]; }); }
      else if (t < 6.9) { st = 'amount'; amtT.forEach(function (s, i) { if (t > s) n = i + 1; if (t > s && t < s + .18) press = [1, 13, 13, 13][i]; }); if (t > 6.6 && t < 6.8) press = 11; }
      else if (t < 7.3) st = 'proc';
      else if (t < 8.6) st = 'card';
      else if (t < 11.2) st = 'cash';
      else st = 'thanks';
      keys.forEach(function (k, i) { k.position.z = i === press ? .45 : .62; });
      ledMat.emissiveIntensity = st === 'welcome' || st === 'card' ? .5 + .5 * Math.abs(Math.sin(time * 4)) : .25;
      var anim = st === 'welcome' || st === 'amount' || st === 'proc';
      var keyStr = st + n;
      if (anim || keyStr !== as.key) { as.key = keyStr; atmUI(st, n, time); }
      var out = seg(t, 8.9, 9.7), take = seg(t, 10.6, 11.4);
      notes.position.z = mix(1.4, 5.6, out) + take * 6; notes.position.y = -11.2 + take * 2.5;
      noteMat.opacity = 1 - take; notes.visible = t > 8.8 && t < 11.5;
      say(st === 'welcome' ? 'Insert your card, chip first' : st === 'pin' ? 'Enter your PIN' : st === 'amount' ? 'Choose the amount' : st === 'proc' ? 'Please wait' : st === 'card' ? 'Take your card' : st === 'cash' ? 'Collect your cash' : 'Done. Same as any bank card');
    }

    /* ---------- camera + interaction ---------- */
    var yaw = 0, pitch = 0, tYaw = 0, tPitch = 0, hov = 0, hovY = 0, drag = null, lastMove = 0;
    canvas.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, y: e.clientY }; stage.classList.add('is-drag'); try { canvas.setPointerCapture(e.pointerId); } catch (_) {} kick(); });
    canvas.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      if (drag) {
        tYaw = clamp(tYaw + (e.clientX - drag.x) * .012, -1.3, 1.3); tPitch = clamp(tPitch + (e.clientY - drag.y) * .006, -.35, .45);
        drag.x = e.clientX; drag.y = e.clientY; lastMove = performance.now(); kick();
      } else if (e.pointerType === 'mouse') { hov = ((e.clientX - r.left) / r.width - .5) * .35; hovY = ((e.clientY - r.top) / r.height - .5) * .12; kick(); }
    });
    function end() { drag = null; stage.classList.remove('is-drag'); lastMove = performance.now(); }
    canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end);
    canvas.addEventListener('pointerleave', function () { hov = 0; hovY = 0; if (drag) end(); });

    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-pay-mode'); t0 = performance.now(); ps.key = as.key = '';
        tabs.forEach(function (o) { o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
        pos.visible = mode === 'pos'; atm.visible = mode === 'atm'; tYaw = 0; tPitch = 0; kick();
      });
    });
    pos.visible = true; atm.visible = false;

    function size() {
      var w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return;
      R.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); kick();
    }
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(stage); else window.addEventListener('resize', size);
    size();

    var visible = true, raf = 0;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); }).observe(stage);
    document.addEventListener('visibilitychange', kick);
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    api.kick = kick;

    function frame(now) {
      raf = 0;
      var M = MODES[mode], time = now / 1000;
      var t = reduce ? M.rest : ((now - t0) / 1000) % M.dur;
      if (mode === 'pos') runPos(t, time); else runAtm(t, time);
      if (!drag && now - lastMove > 1400) { tYaw *= .96; tPitch *= .96; }
      yaw += (tYaw - yaw) * .1; pitch += (tPitch - pitch) * .1;
      var sway = reduce ? 0 : Math.sin(time * .6) * .07;
      var g = mode === 'pos' ? pos : atm;
      g.rotation.set(0, 0, 0);
      var rig = mode === 'pos' ? posRig : atmRig;
      rig.rotation.set(M.pitch + pitch + hovY, M.yaw + yaw + sway + hov, 0);
      var tg = M.target;
      cam.position.set(tg[0], tg[1] + 4, tg[2] + M.dist); cam.lookAt(tg[0], tg[1], tg[2]);
      R.render(S, cam);
      var active = !reduce || drag || Math.abs(tYaw - yaw) > .002 || Math.abs(tPitch - pitch) > .002;
      if (visible && !document.hidden && active) kick();
    }
    stage.classList.add('is-ready');
    kick();
  }
})();
